<mat-calendar
    [class.drc-readonly]="readOnly"
    [selected]="calSelected"
    [startAt]="calStart"
    [minDate]="calMinDate"
    [maxDate]="calMaxDate"
    [dateClass]="dateClass"
    (selectedChange)="onCalSelect($event)"
></mat-calendar>
@if (readOnly) {
<div class="drc-ro" aria-label="Selected window">
    <div class="drc-ro__row">
        <span class="drc-ro__lbl">From</span>
        <span class="drc-ro__val">{{ customStartDate }} <b>{{ customStartTimeDisplay }}</b></span>
    </div>
    <div class="drc-ro__row">
        <span class="drc-ro__lbl">To</span>
        <span class="drc-ro__val">{{ customEndDate }} <b>{{ customEndTimeDisplay }}</b></span>
    </div>
</div>
}
@if (!readOnly) {
<div class="drc-dt">
    <label class="drc-dt__row">
        <span class="drc-dt__lbl">From</span>
        <input
            type="text"
            class="drc-dt__in drc-dt__in--date"
            inputmode="text"
            [placeholder]="dateHint"
            [value]="customStartDate"
            (change)="onStartDateInput($event)"
        />
        <input
            type="text"
            class="drc-dt__in drc-dt__in--time"
            inputmode="text"
            [placeholder]="timeHint"
            [value]="customStartTimeDisplay"
            (change)="onStartTimeInput($event)"
        />
    </label>
    <label class="drc-dt__row">
        <span class="drc-dt__lbl">To</span>
        <input
            type="text"
            class="drc-dt__in drc-dt__in--date"
            inputmode="text"
            [placeholder]="dateHint"
            [value]="customEndDate"
            (change)="onEndDateInput($event)"
        />
        <input
            type="text"
            class="drc-dt__in drc-dt__in--time"
            inputmode="text"
            [placeholder]="timeHint"
            [value]="customEndTimeDisplay"
            (change)="onEndTimeInput($event)"
        />
    </label>
    @if (rangeError) {
        <div class="drc-dt__error" role="alert">{{ rangeError }}</div>
    }
    <div class="drc-dt__actions">
        <button type="button" class="drc-dt__btn drc-dt__btn--ghost" (click)="onCancel()">Cancel</button>
        <button type="button" class="drc-dt__btn drc-dt__btn--apply" [disabled]="!canApply" (click)="onApply()">Apply</button>
    </div>
</div>
}
